module.exports = __webpack_public_path__ + "imgs/share-wechat-area@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-wechat-area@2x.png
// module id = 231
// module chunks = 93